import CleanModal from './CleanModal';

export default CleanModal;
